export default __webpack_public_path__ + "static/media/history.c3f6afeb.svg";